import { slugify } from "../slug";
import type { LegalDocument, LegalSection } from "./types";

export type LegalOutlineEntry = { id: string; heading: string; section: LegalSection };

export const legalSectionId = (section: LegalSection): string => section.id ?? slugify(section.heading);

export const legalOutline = (doc: LegalDocument): LegalOutlineEntry[] =>
  doc.sections.map((section, index) => ({
    id: legalSectionId(section),
    heading: doc.numbered ? `${index + 1}. ${section.heading}` : section.heading,
    section,
  }));
